import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { getRouteUrl } from '@utils/urls';

import CMSComponentsRenderer from '@common/components/CMSComponents/CMSComponentsRenderer';
import HTMLRenderer from '@common/components/CMSComponents/HTMLRenderer';
import Layout from '@common/containers/Layout';
import RouteLayout from '@common/containers/RouteLayout';
import { HOME, DELIVERY_CONDITIONS } from '@common/routes';
import Typography from '@common/components/Typography';

import { Header, Lead } from './DeliveryConditions.styled';

const DeliveryConditions = ({ pageData: { lead, title, body, meta } }) => {
  const { locale } = useRouter();

  return (
    <Layout
      title={meta.metaTitle}
      description={meta.metaDescription}
      canonicalPageUrl={getRouteUrl(locale, DELIVERY_CONDITIONS)}
    >
      <RouteLayout
        backRoute={HOME}
        backRouteAs={getRouteUrl(locale, HOME)}
        stickyTitle={title}
        columns={8}
      >
        <Header>
          <Typography customAs="h1" variant="h2">
            {title}
          </Typography>
          {lead && (
            <Lead>
              <HTMLRenderer customAs="span" html={lead} nl2br />
            </Lead>
          )}
        </Header>
        <CMSComponentsRenderer body={body} />
      </RouteLayout>
    </Layout>
  );
};

DeliveryConditions.propTypes = {
  pageData: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string.isRequired,
    lead: PropTypes.string,
    meta: PropTypes.shape({
      metaDescription: PropTypes.string,
      metaTitle: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default DeliveryConditions;
